export default {
    "type": "object",
    "required": [ "orderno", "ordertype", "dateinstall", "svcno", "cafsno", "orderstatus", "bpid", "bpopid", "region" ],
    "properties": {
        "orderno": {
            "type": "string",
            "title": "Order No.",
            "default": "",
            "x-cols": "6",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
            }
        },
        "ordertype": {
            "type": "string",
            "title": "Order Type",
            "default": "",
            "x-class": "pr-2",
            "x-cols": "6",
            "x-props": {
                "readonly": false
            }
        },
        "dateinstall": {
            "type": "string",
            "title": "Date Install",
            "format": "date",
            "x-class": "pr-2",
            "x-cols": "6",
            "x-props": {
                "readonly": false,
            }
        },
        "svcno": {
            "type": "string",
            "title": "Service No.",
            "default": "",
            "x-class": "pr-2",
            "x-cols": "4",
            "x-props": {
                "readonly": false
            }
        },
        "svctype": {
            "type": "string",
            "title": "Service No. Type",
            "default": "HSBB",
            "x-class": "pr-2",
            "x-cols": "2",
            "enum": [
                "HSBB",
                "HSBA"
            ],
            "x-props": {
                "readonly": false,
            }
        },
        "cafsno": {
            "type": "string",
            "title": "CAF Serial No.",
            "default": "",
            "x-class": "pr-2",
            "x-cols": "6",
            "x-props": {
                "readonly": false,
            }
        },
        "orderstatus": {
            "type": "string",
            "title": "Order Status",
            "default": "",
            "x-class": "pr-2",
            "x-cols": "6",
            "x-props": {
                "readonly": false
            }
        },
        "remarks": {
            "type": "string",
            "title": "Remarks",
            "default": "",
            "x-class": "pr-2",
            "x-cols": "12",
            "x-props": {
                "readonly": false,
            },
            "x-display": "textarea"
        },
        "bpid": {
            "type": "integer",
            "title": "Business Partner",
            "default": "",
            "x-class": "pr-2",
            "x-cols": "6",
        },
        "bpopid": {
            "type": "integer",
            "title": "Operator",
            "default": "",
            "x-class": "pr-2",
            "x-cols": "6",
        },
        "ordertotalcost": {
            "type": "number",
            "title": "Total Cost",
            "default": "",
            "x-class": "pr-2",
            "x-cols": "6",
        },
        "region": {
            "type": "string",
            "title": "Region",
            "default": "",
            "x-class": "pr-2",
            "x-cols": "6",
        },
        "dummyextras": {
            "type": "string",
            "x-cols": "6",
            "title": "Extra Charges"
        },
        "dummyfiles": {
            "type": "string",
            "x-cols": "6",
            "title": "Images"
        }
    }
}
